import React from 'react';
import { AnimatedSection } from './AnimatedSection';
import { ArrowRight } from 'lucide-react';
export function ExpectationsSection() {
  return <section className="py-20 px-6 md:px-8 max-w-2xl mx-auto" data-id="element-22">
      <AnimatedSection data-id="element-23">
        <h2 className="text-3xl md:text-4xl font-serif text-bark mb-8 text-center" data-id="element-24">
          Lo que podés esperar en 21 días
        </h2>

        <div className="space-y-6 text-lg text-bark/90 leading-relaxed mb-12" data-id="element-25">
          <p data-id="element-26">No te prometo una vida perfecta.</p>
          <p data-id="element-27">Te prometo algo más real:</p>

          <ul className="space-y-3 pl-4 border-l-2 border-gold/30 my-6" data-id="element-28">
            <li className="pl-4" data-id="element-29">
              que vuelvas a rezar{' '}
              <span className="font-bold" data-id="element-30">sin negociarlo</span>,
            </li>
            <li className="pl-4" data-id="element-31">que la culpa baje,</li>
            <li className="pl-4" data-id="element-32">que tu fe deje de depender del ánimo,</li>
            <li className="pl-4" data-id="element-33">
              que sepas exactamente qué hacer cuando te caés.
            </li>
          </ul>
        </div>

        <div className="bg-parchment p-8 rounded-sm text-center shadow-inner" data-id="element-34">
          <p className="text-bark/70 font-serif italic mb-4" data-id="element-35">Vas a pasar de:</p>

          <div className="flex flex-col md:flex-row items-center justify-center gap-4 md:gap-8" data-id="element-36">
            <span className="text-xl text-bark/60" data-id="element-37">“mañana empiezo”</span>
            <ArrowRight className="text-gold rotate-90 md:rotate-0" data-id="element-38" />
            <span className="text-2xl md:text-3xl font-serif font-bold text-wine" data-id="element-39">
              “hoy volví”
            </span>
          </div>
        </div>
      </AnimatedSection>
    </section>;
}